var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LineChart',{attrs:{"width":_vm.width,"height":_vm.height,"chart-data":_vm.data,"options":_vm.options}})
}
var staticRenderFns = []

export { render, staticRenderFns }